module.exports = __webpack_public_path__ + "static/media/banner-about.bd1be3a9.svg";